import React from 'react';

interface TopBarProps {
  left?: React.ReactNode;
  center?: React.ReactNode;
  right?: React.ReactNode;
}

export function TopBar({ left, center, right }: TopBarProps) {
  return (
    <div className="topbar">
      <div className="tb-left">{left}</div>
      {center !== undefined && <div className="tb-center">{center}</div>}
      <div className="tb-right">{right}</div>
    </div>
  );
}
